<template>
    <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
        <i class="fa fa-download"></i>
        {{ $t('export') }}
        <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
            no-enforce-focus>
            <div class="alert alert-warning">
                <span>{{ $t('exportNotice') }}</span>
            </div>
            <b-progress :max="totalCount">
                <b-progress-bar :value="downloadedCount"
                    :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
            </b-progress>
        </b-modal>
    </button>
</template>


<script>
import { saveAs } from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
    props: ['filter', 'totalCount'],
    data() {
        return {
            exporting: false,
            cancelRequest: false,
            downloadedCount: 0
        }
    },
    methods: {
        exportTransaction: async function () {
            this.downloadedCount = 0;
            this.exporting = true;
            let workbook = new Excel.Workbook();
            let sheet = workbook.addWorksheet('data');
            this.setupSheet(sheet);

            let response = null;
            let params = Object.assign({}, this.filter);
            params.page = 1;
            params.pageSize = 500;
            do {
                if (this.cancelRequest) {
                    break;
                }
                let result = await this.$service.get('/facebook', {
                    params: params
                });
                params.page += 1;
                response = result.data;
                response.docs.forEach(item => {
                    let status = '';
                    if (!item.sendTime) {
                        status = this.$t('notYetSent');
                    }
                    if (item.sendTime && !item.sendError) {
                        status = this.$t('sent');
                    }
                    if (item.sendTime && item.sendError) {
                        status = this.$t('sentFail');
                    }
                    let row = {
                        account: item.account && item.account.name ? item.account.name : '',
                        user: item.user && item.user.name ? item.user.name + ` (${item.user.ext})` : '',
                        facebookId: item.facebookId ? item.facebookId : '',
                        createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
                        sendTime: moment(item.sendTime).format('DD/MM/YYYY HH:mm:ss'),
                        messageCampaign: item.messageCampaign ? item.messageCampaign.name : '',
                        template: item.template && item.template.name ? item.template.name : '',
                        type: item.type ? this.$t(item.type + 'Template') : '',
                        status: status,
                        sendErrorMsg: item.sendErrorMsg ? item.sendErrorMsg : ''
                    }
                    sheet.addRow(row);
                    this.downloadedCount += 1;
                });
            } while (response && response.hasNextPage);

            workbook.xlsx.writeBuffer({ base64: true }).then(data => {
                this.exporting = false;
                saveAs(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                    'facebook-history.xlsx');
            }).finally(() => {
                this.cancelRequest = false;
                this.downloadedCount = 0;
            });
        },
        setupSheet: function (sheet) {
            sheet.columns = [
                { header: 'Facebook page', key: 'account', width: 15 },
                { header: this.$t('user'), key: 'user', width: 20 },
                { header: 'Facebook ID', key: 'facebookId', width: 15 },
                { header: this.$t('createTime'), key: 'createTime', width: 20 },
                { header: this.$t('sendTime'), key: 'sendTime', width: 20 },
                { header: this.$t('messageCampaigns'), key: 'messageCampaign', width: 30 },
                { header: this.$t('template'), key: 'template', width: 30 },
                { header: this.$t('type'), key: 'type', width: 15 },
                { header: this.$t('status'), key: 'status', width: 15 },
                { header: this.$t('sendErrorMsg'), key: 'sendErrorMsg', width: 15 },
            ];
        },
        close() {
            this.cancelRequest = true;
        }
    },
    i18n: {
        messages: {
            en: {
                buttonTemplate: "Button",
                couponTemplate: "Coupon",
                customer_feedbackTemplate: "Customer feedback",
                genericTemplate: "Generic",
                mediaTemplate: "Media",
                customer_informationTemplate: "Customer information",
            },
            vi: {
                buttonTemplate: "Nút bấm",
                couponTemplate: "Mã giảm giá",
                customer_feedbackTemplate: "Phản hồi của khách hàng",
                genericTemplate: "Mẫu chung",
                mediaTemplate: "Đa phương tiện",
                customer_informationTemplate: "Thông tin khách hàng",
            }
        }
    }

}
</script>